import getuser from '../aws_utils/getAuthuser';
// import { MemoryVectorStore } from "langchain/vectorstores/memory";
// import { OpenAIEmbeddings } from "langchain/embeddings/openai";
// import { Document } from 'langchain/document';
// import { RecursiveCharacterTextSplitter } from 'langchain/text_splitter';
import { BufferWindowMemory } from 'langchain/memory';
import { addProjectChat } from '../apigateway/mongocalls';
import { invokeDocumentAgentApi } from '../apigateway/agentcalls';

export default async function jsonsummaryv3(docs, query, projectname, projectconversation) {
 

if(projectname === "" || projectname === undefined){
    alert("Select or Start New Project!")
    return
}


let userid = ""
try {
    const user = await getuser()
    userid = user.username
} catch (error) {
    console.log(error)
}


// Add memory
// const userchat = await getProjectChats(projectname)

// Buffer Window Memory
const memory = new BufferWindowMemory({});
// console.log('memory', memory);


if(projectconversation.length === 0){
    // console.log("No User Chats!")
    } else {
    
        
    // console.log("User Chats Exist!")
    // Save user project chats into memory
    projectconversation.forEach(async item => {
        // console.log("Query", item.query)
        // console.log("Response", item.response)
        
        if(item.query === null && item.response){
            // console.log("1")
        await memory.saveContext(
            {input: "..."},
            {output: item.response}
        )
        return
        }

        if(item.response === null && item.query){
            // console.log("2")
        await memory.saveContext(
            {input: item.query},
            {output: "..."},
            )
            return
        }

        if(item.response === null && item.query === null){
            // console.log("3")
            // No query or response
            return
        }

        // console.log("4")
        await memory.saveContext(
            {input: item.query},
            {output: item.response},
        )

        });
    }


    // const history = await memory.loadMemoryVariables({ k : 4 , returnMessages: true });
    const messages = await memory.chatHistory.getMessages();
    const basemessages = memory.chatHistory.messages
    
    // console.log("history", history); 
    // console.log("messages", messages);
    // console.log('base messages', basemessages);
   
// Custom Filter CHat History Function...
const serializeChatHistory = (chatHistory) => {
    let aiCount = 0;
    let humanCount = 0;
    const serializedMessages = chatHistory.map((chatMessage) => {
        if (chatMessage._getType() === "human" && humanCount < 4) {
            humanCount++;
            return `Human: ${chatMessage.content}`;
        } else if (chatMessage._getType() === "ai" && aiCount < 4) {
            aiCount++;
            return `Assistant: ${chatMessage.content}`;
        } else {
            return null;
        }
    }).filter(message => message !== null)
    return serializedMessages;
}
// .join("\n");



const oldmem = await serializeChatHistory(messages);
const recentmem = await serializeChatHistory(basemessages.reverse());
// console.log('Last 4 chats in Project...', oldmem); 
// console.log('First 4 chats in Project...', recentmem);
const sumupmemory = { 
    "____OLDEST CHAT HISTORY____": oldmem,
    "____MOST RECENT CHAT HISTORY____": recentmem.reverse(),   
}
const memorysummary = JSON.stringify(sumupmemory);
// console.log('Complete Memmory..', memorysummary);



// Old Handle selected Document(s) -> Take rawtext and create doucments
// console.log("Summary Start On These Docs:", docs.documents_selected)
// const text = JSON.stringify(docs.documents_selected)
// // console.log("Stringify docs", text)
// const textSplitter = new RecursiveCharacterTextSplitter({ 
//     chunkSize: 700,
//     chunkOverlap: 10,
    
// });
// const documents = await textSplitter.createDocuments([text]);
// console.log("Split text into multiple documents to vectorize...", documents.length)
// console.log("Documents to vectorize...", documents)




// Handle selected documents -> Take all lang_documents (DOCUMENTS from pdf loader)for documents and combine them!
// const all_lang_documents = []
// let documents_selected = [{}]
// let querydocs = ''
// documents_selected = docs.documents_selected;

// if(documents_selected === "no documents selected, answer user question"){
//     querydocs = "no documents selected, just answer human question."
    
// } else {

// documents_selected.forEach(doc => {
//     // console.log(`Adding lang_docs from ${doc.key}: ${doc.lang_documents.length} docs`);
//     let lang_docs = [{}]
//     let updateKey = ''
//     updateKey = doc.key;
//     const updatedKey = updateKey.replace(`${projectname}`,"");
//     lang_docs = doc.lang_documents
//     lang_docs.forEach(langDocObj => {
//         const officialLangDoc = new Document(langDocObj);
//         // console.log('old meta', officialLangDoc.metadata);
//         officialLangDoc.metadata = { title: updatedKey, type: 'pdf', pageNumber: officialLangDoc.metadata.loc.pageNumber, totalPages: doc.lang_documents.length }
//         // console.log('updated meta for lang doc', officialLangDoc);
//         all_lang_documents.push(officialLangDoc);
//     })
// })

// // console.log('All documents selected lang documents length', all_lang_documents.length);
// // console.log('All documents selected lang documents', all_lang_documents);

// // Add Documents To Vector Store
// const vectorStore = await MemoryVectorStore.fromDocuments(
//     all_lang_documents,
//     new OpenAIEmbeddings({
//         openAIApiKey: process.env.REACT_APP_REALM_OPENAI,
//     }),
//   );

// // console.log("Vector Store of Documents?", vectorStore)

// // Query Vector store for similar docs
// const similardocuments = await vectorStore.similaritySearch(query, all_lang_documents.length > 200 ? 15 : 10);
// // Helpful
// // console.log("Vector Similarity Search on Documents", similardocuments)
// // console.log("Vector Similarity Search on Documents Length", similardocuments.length)


// // Cleaning up the vector similarity search 
// // const serializeDocs = (docs) => {
// //   const d = docs.map((doc) => doc.pageContent).join("\n\n")
// // //   console.log(d)
// //     return d
// //   }
// // queryDocs = serializeDocs(similardocuments);
// // console.log("similar Docs after serialized", similardocs)

// // Passing string Documents because it holds metadata
// querydocs = JSON.stringify(similardocuments)
// // console.log("Vector Similarity Search on Documents", stringSimilarDocs )

// // Query Vector store for relevant docs
// // const retriever = vectorStore.asRetriever()
// // const releventdocuments = await retriever.getRelevantDocuments(query)
// // console.log("Vector Relevent Search on Documents", releventdocuments)
// // console.log("Vector Relevent Search on Documents length", releventdocuments.length)
// // queryDocs = serializeDocs(releventdocuments)
// // queryDocs = JSON.stringify(releventdocuments)
// // console.log('relevant documents?', relevantdocs);

// }

// Old Lmabda call
// const response = await invokedocumentagent(query, memorysummary, similardocs)
// const parseresponse = JSON.parse(response)


// Invoke Document Agent Api
const response = await invokeDocumentAgentApi(query, memorysummary, docs.documents_selected, projectname);
// console.log('document agent response', agentresponse);

let finalresp 
    if(response === `error`){
        finalresp = `Request Timed Out... Try query again`
    }
    if(response === null || response === undefined || response === ''){
        finalresp = `Try rephrasing or simiplifying your query!`  
    } 
    if(response === `Agent stopped due to max iterations.`){
        finalresp = `Try rephrasing or simiplifying your query!`
    } 
    if(response !== null && response !== `error` && response !== `Agent stopped due to max iterations.`){
        finalresp = response
    }


    const addChatPackage = {
    "project": projectname,
    "userId": userid,
    "query": query,
    "response" : finalresp,  
    "agent" : "document agent" 
    }
    const result = await addProjectChat(addChatPackage);
   
    


    const output = {
    "result": result,
    "response": finalresp,
    }

// console.log('ouput json summary', output);

    return output





}